<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <!-- <a class="navbar-brand ml-3">Cek Nomor TO/NOPOL</a> -->
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor TO/NOPOL"
                        aria-label="Search"
                        v-model="filter.search"
                        style="font: normal normal normal 16px/25px Poppins;"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold;
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Body Start -->
        <div class="innerBox">
            <!-- Title & Option Buttons Start -->
            <div class="mb-4 row">
                <div class="col-md-3">
                    <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
                </div>
                <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">Validasi Pengiriman Barang</h3>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                    <div class="d-flex">
                        <div class="col-4" style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                            <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                        </div>
                        <div class="col-8" style="font: normal normal normal 12px/18px Poppins;">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                                style="font: normal normal normal 12px/18px Poppins;"
                            ></flat-pickr>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Title & Option Buttons End -->

            <!-- Table Start -->
            <div style="z-index:10;">
                <vue-universal-table
                    api_url="/api/validation/documentList"
                    :filter="filter"
                    :fields="vue_universal_table.fields"
                    :update="vue_universal_table.update"
                    :buttons="vue_universal_table.buttons"
                    :infinite_scroll="true"
                    :process_data="vue_universal_table.process_data"

                    sort_order="DESC"
                    sort_by="tanggal_dokumen"
                    class="vue-universal-table"
                    style_button="true"

                    @onValidasiDetail="editData"
                    @onPosting="postingData"
                    @onForcePosting="forcePostingData"
                    
                ></vue-universal-table>
            </div>
            <!-- Table End -->

            <!-- Modal Start -->
            <div style="position: relative;">
                <validasi-kedatangan-truck-detail
                    v-if="modal.edit"
                    :edit_data="modal.editData"
                    api_get="/api/validation/documentDetail"
                    @refreshData="vue_universal_table.update++;"
                    @closeModal="modal.edit = false;"
                ></validasi-kedatangan-truck-detail>
            </div>
            <!-- Modal End -->

            <PostingTOModal 
                v-if="modal.new"
                :data="modal.postingData"
                :title="'Posting TO'"
                @closeModal="modal.new = false"
                @updateTable="vue_universal_table.update++;"
            />

            <ForcePostingModal
                v-if="modal.forcePosting"
                :data="modal.forcePostingData"
                title="Apakah Anda Yakin?"
                @closeModal="modal.forcePosting = false"
                @updateTable="vue_universal_table.update++;"
            />

        </div>
        <!-- Body End -->
    </div>
</template>

<script>
    import moment from 'moment'
    import debounce from 'debounce';
    import validasiKedatanganTruckDetail from './children/ValidasiKedatanganTruckDetail'
    import PostingTOModal from './children/PostingTOModal.vue';
    import ForcePostingModal from './children/ForcePostingModal.vue';
    import "./children/validasiStyle.css";
    // import Modal from './ValidasiKedatanganTruckModal.vue'
    // import axios from 'axios';

    export default {
        metaInfo : {
            title : 'Validasi Ked. Truck'
        },
        data () {
        
            let startDate = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                modal : {
                    new : false,
                    forcePosting : false,
                    edit : false,
                    editData : null,
                    postingData : null,
                    forcePostingData : null
                },
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input elegant-flatpickr'
                },
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    search : null,
                },
                vue_universal_table : {
                    fields : [
                        {title:"NO TO", variable:"no_to"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"JUMLAH SJ", variable:"jumlah_sl"},
                        {title:"DRIVER", variable:"driver"},
                        {title:"STATUS", variable:"status_validasi"},
                        {title:"Tanggal", variable:"tanggal_dokumen"},
                    ],
                    buttons : [
                        {title : "validasiDetail", class : "fas fa-pen btn border border-secondary rounded shadow",},
                        {title : "posting", class : "btn border border-secondary rounded shadow"},
                        {
                            title : "forcePosting",
                            class : "btn border border-secondary rounded shadow",
                            condition : "data.status_validasi == 'Validasi'"
                        },
                    ],
                    filter : {},
                    update : 0,
                    process_data : `
                        for(var i = 0 ; i < data.length ; i++) {
                            data[i].jumlah_sl = data[i].jumlah_terkirim + ' / ' + data[i].jumlah_sl;
                            data[i].driver = data[i].driver.replace(/[^a-zA-Z0-9]/g, " ");
                        }
                    `
                },
            }
        },
        components : {
            validasiKedatanganTruckDetail,
            PostingTOModal,
            ForcePostingModal
        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];

                //Check End
                if (this.filter.end != moment().format('YYYY-MM-DD')){
                    this.selected.dateButtonsIndex = -1;
                //Check Start
                } else if (this.options.dateButtons.map(x=>x.start).indexOf(this.rangePickr.start) == -1) {
                    this.selected.dateButtonsIndex = -1;
                //Found Match
                } else {
                    this.selected.dateButtonsIndex = this.options.dateButtons.map(x=>x.start).indexOf(this.rangePickr.start);
                }

                this.vue_universal_table.update++;
                this.modal.edit = false
                this.modal.new = false
            },
            'selected.dateButtonsIndex' () {
                // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
            },
            'filter' : {
                deep : true,
                handler : 'emitFilter'
            },
        },
        methods : {
            editData (data) {
                this.modal.editData = data
                this.modal.edit = true
            },
            postingData (data) {
                this.modal.postingData = JSON.parse(data)
                this.modal.edit = false
                this.modal.forcePosting = false
                this.modal.new = true
            },
            forcePostingData (data) {
                this.modal.forcePostingData = JSON.parse(data)
                this.modal.edit = false
                this.modal.new = false
                this.modal.forcePosting = true
            },
            selectDateButton (i) {
                this.selected.date = `${this.options.dateButtons[i].start} to ${this.options.dateButtons[i].end}`
                this.selected.dateButtonsIndex = i;
            },
            debouncelessEmitFilter () {
                this.$emit('filterChange', this.vue_universal_table.update++);
            },
            emitFilter: debounce(function () {
                this.$emit('filterChange', this.vue_universal_table.update++);
            }, 1500)
        },
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');
    .vue-universal-table {
        font-family: 'Poppins', sans-serif !important;
    }
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
        font: normal normal normal 12px/18px Poppins;
    }
</style>
